import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/pt-br/disclaimer")({
  head: () => ({
    meta: [
      { title: "Aviso Legal — Picamini.online" },
      {
        name: "description",
        content: "Aviso legal e isenção de responsabilidade sobre o uso dos serviços do Picamini.online.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/pt-br/aviso-legal" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/disclaimer" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/aviso-legal" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/haftungsausschluss" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/aviso-legal" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/disclaimer" },
    ],
  }),
  component: PtBrDisclaimerPage,
});

function PtBrDisclaimerPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="pt-BR" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Aviso Legal</h1>
        <p className="text-sm text-muted-foreground">Última atualização: Setembro de 2026</p>

        <p className="text-base text-muted-foreground leading-relaxed">
          As informações e ferramentas disponibilizadas no site <strong>Picamini.online</strong> são fornecidas "como estão", sem garantias explícitas ou implícitas de qualquer natureza.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">1. Isenção de Garantias</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Embora nos esforcemos para garantir que todas as ferramentas funcionem com alta precisão e sem erros, o Picamini.online não se responsabiliza por eventuais falhas técnicas, corrupção imprevista de arquivos ou indisponibilidades temporárias do serviço.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">2. Links Externos</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Nosso site pode conter links para sites de parceiros ou terceiros. Não exercemos controle sobre o conteúdo ou práticas de privacidade desses sites externos.
        </p>
      </main>

      <SiteFooter lang="pt-BR" />
    </div>
  );
}
